import React, { useState, useEffect } from "react";
import "../myschedule.scss";
import moment from "moment";
import FilterMenuList from "../../../common/Modules/FilterMenuList";
import { ClickAwayListener } from "@material-ui/core";
import DatePicker from "../../../common/Modules/DatePicker";

const ViewLogsHeader = ({
  params,
  headerData,
  applyParams,
  selectedRadioBtn,
  logFilterData,
}) => {
  const [data, setData] = useState();
  const [clonedArray, setCloneArray] = useState();
  const [selectedRange, setSelectedRange] = useState(null);
  const [tempDateRange, setTempDateRange] = useState(null);

  
  // Life Cycle //
  useEffect(() => {
    let clonedArray = headerData.map((a) => {
      return { ...a };
    });
    setCloneArray(clonedArray);
    setData(headerData);
  }, [headerData]);

  useEffect(() => {
    let rangeData = {
      dateDisplayFormat: "DD MMM YYYY",
      rangeColors: "#F969A4",
      color: "#F969A4",
      key: "selection",
    };
    if (logFilterData?.start_date && logFilterData?.end_date) {
      handleOnChange({
        ...selectedRange,
        startDate: new Date(logFilterData?.start_date),
        endDate: new Date(logFilterData?.end_date),
        dateFilterLabel: logFilterData?.dateFilterLabel,
        ...rangeData,
      });
    } else {
      handleOnChange({
        ...selectedRange,
        startDate: new Date(),
        endDate: new Date(),
        dateFilterLabel: "today",
        ...rangeData,
      });
    }
  }, [headerData]);

  useEffect(() => {
    if (selectedRadioBtn) {
      setTempDateRange("");
    }
  }, [selectedRadioBtn]);

  // ------------- //
  const onFilterClick = (obj) => {
    if (obj.filter_type === "normal") {
      let dataCopy = [...data];
      dataCopy.forEach((header) => {
        if (header.title === obj.title) {
          obj.menuData = obj.tempMenu;
          obj.show_filter = true;
        }
      });
      setData(dataCopy);
    } else if (obj.filter_type === "date") {
      let dataCopy = [...data];
      obj.show_filter = true;
      setData(dataCopy);
    }
  };
  const hideFilter = (obj) => {
    let dataCopy = [...data];
    dataCopy.forEach((header) => {
      if (header.title === obj.title) {
        obj.show_filter = false;
      }
    });
    setData(dataCopy);
    setSelectedRange(tempDateRange);
  };

  const toggleItems = (item, obj) => {
    let dataCopy = [...data];
    dataCopy.forEach((da) => {
      if (da.title === obj.title) {
        da.menuData.forEach((menu) => {
          if (menu.value.toLowerCase() === item.value.toLowerCase()) {
            menu.selected = true;
          } else {
            menu.selected = false;
          }
        });
        da["show_filter"] = false;
      }
    });
    setData(dataCopy);
    handleApplyFilter();
  };

  const handleApplyFilter = () => {
    let obj = { ...params };
    let allSelectedDate = {};
    let selectedValue = headerData;
    selectedValue.forEach((data) => {
      allSelectedDate = getSelectedData(data?.mobileFilterTitle);
      obj = { ...obj, ...allSelectedDate, page_number: 1 };
    });
    applyParams(obj);
  };

  const getSelectedData = (filterName) => {
    let data = headerData;
    let index = data.findIndex(
      (data) => data?.mobileFilterTitle === filterName
    );
    let selectedData = headerData[index]?.menuData?.find(
      (val) => val.selected === true
    );
    switch (filterName) {
      case "CONSULTATION":
        return { consultation_filter: selectedData?.name };
      case "ACTION":
        return { action_filter: selectedData?.value };
      case "ROLE":
        return { role_filter: selectedData?.value };
      case "ROLE NAME":
        return { doctor_name_filter: selectedData?.value };
      default:
        return "";
    }
  };

  const handleFilterSearch = (key, obj) => {
    let dataCopy = [...data];
    dataCopy.forEach((da) => {
      if (da.title === obj.title) {
        let filteredItems = da.menuData.filter((data) =>
          data.name?.toLowerCase().includes(key.toLowerCase())
        );
        obj.menuData = filteredItems.length > 0 ? filteredItems : [];
      }
    });
    if (key.length > 0) {
      setData(dataCopy);
    } else {
      let dataCopy = [...data];
      let original_menu_data = clonedArray.filter((da) => {
        if (obj.title === da.title) {
          return da.menuData;
        }
      });
      dataCopy.forEach((da) => {
        if (da.title === obj.title) {
          obj.menuData = original_menu_data[0].menuData;
        }
      });
      setData(dataCopy);
    }
  };

  const applyDateFilter = (dates, dateObj) => {
    let obj = {
      ...params,
      start_date: moment(dates?.startDate).format("YYYY-MM-DD"),
      end_date: moment(dates?.endDate).format("YYYY-MM-DD"),
      page_number: 1,
      dateFilterLabel: dates?.dateFilterLabel,
    };
    setTempDateRange(dates);
    hideFilter(dateObj);
    applyParams(obj);
  };

  const handleOnChange = (ranges) => {
    let isMoreThanTwoMonths =
      moment(ranges.endDate).toDate() >
      moment(ranges.startDate).add(2, "months").toDate();

    if (isMoreThanTwoMonths) {
      ranges.endDate = moment(ranges.startDate).add(2, "months").toDate();
    }
    setSelectedRange(ranges);
  };

  const renderFilter = (obj) => {
    return (
      obj.filter_icon && (
        <div
          className="mx-1"
          style={{
            position: "relative",
          }}
        >
          <img
            onClick={() => onFilterClick(obj)}
            src={obj.filter_icon}
            alt=""
          />
          {obj.show_filter && obj.filter_type === "normal" && (
            <ClickAwayListener onClickAway={() => hideFilter(obj)}>
              <div
                className={`view-logs-header-filter ${
                  obj.title === "ROLE NAME"
                    ? "view-logs-header-filter-transform"
                    : ""
                }`}
              >
                <div
                  className={`${
                    obj.title === "CONSULTATION" || obj.title === "ROLE NAME"
                      ? "filter-menu-custom-dropdown-height"
                      : ""
                  }`}
                >
                  <FilterMenuList
                    menuItemList={obj.menuData}
                    show_filter_searchbar={obj.show_search}
                    handleFilterSearch={(key) => handleFilterSearch(key, obj)}
                    toggleItems={(item) => toggleItems(item, obj)}
                    placeholderForSearch={obj.placeholder}
                  />
                </div>
              </div>
            </ClickAwayListener>
          )}
          {obj.show_filter && obj.filter_type === "date" && (
            <ClickAwayListener onClickAway={() => hideFilter(obj)}>
              <div className="view-logs-header-date-picker">
                <DatePicker
                  maxDate={moment().toDate()}
                  selectedRange={selectedRange}
                  closeDatePicker={() => hideFilter(obj)}
                  handleOnChange={handleOnChange}
                  customRangeLabel={
                    <>
                      Custom Date Range
                      <p className="custom-label">
                        Maximum Selection Limit is 2 Months
                      </p>
                    </>
                  }
                  applyRange={(date) => applyDateFilter(date, obj)}
                />
              </div>
            </ClickAwayListener>
          )}
        </div>
      )
    );
  };

  const createHeader = () => {
    return (
      <div className="p-3 d-flex justify-content-between align-items-center flex-wrap">
        {headerData.map((obj, ind) => {
          return (
            <div
              className={`${obj.title === "ACTION" ? "col-3" : "col-2"}`}
              key={ind}
            >
              <div className="d-flex justify-content-start align-items-center">
                <div className="log-header"> {obj.title}</div>
                <div> {renderFilter(obj)}</div>
              </div>
            </div>
          );
        })}
      </div>
    );
  };

  return <>{createHeader()}</>;
};
export default ViewLogsHeader;
